var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { DEPENDENCY_KEYS, useDependency } from '#context';
import { useCurrentMemberByWorkspaceId } from '#query-hooks';
import { useFilespaceUpgradeDisconnect } from '../../../hooks/useFilespaceUpgradeDisconnect';
export const WorkspacePollSideEffects = ({ filespaceList, workspaceId, }) => {
    _react_refresh_temp_2();
    const { query: { data: currentMember }, } = useCurrentMemberByWorkspaceId(workspaceId);
    useDependency(DEPENDENCY_KEYS.UseFilespaceUpgradeNotifier)({
        currentMember,
        filespaceList,
        workspaceId,
    });
    useFilespaceUpgradeDisconnect({
        currentMember,
        filespaceList,
        workspaceId,
    });
    return null;
};
_react_refresh_temp_1 = WorkspacePollSideEffects;
$RefreshReg$(_react_refresh_temp_1, "WorkspacePollSideEffects");
_react_refresh_temp_2(WorkspacePollSideEffects, "z5tOaC/gYCgJMSOn14mEGepygng=", false, () => [useCurrentMemberByWorkspaceId, useDependency, useFilespaceUpgradeDisconnect]);
